import { Component, OnInit, Inject, forwardRef } from '@angular/core';

import { AppComponent } from '../app.component';

@Component({
  selector: 'save-design',
  templateUrl: './save-design.component.html',
  styleUrls: ['./save-design.component.css']
})
export class SaveDesignComponent implements OnInit {

  constructor(@Inject(forwardRef(() => AppComponent)) public parent : AppComponent) { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/jaswantdhayal/Desktop/Projects/seniorJackets/src/app/save-design/save-design.component.ts